export default {"src":"/_next/static/media/second_group_urgent.53cfceae.svg","height":68,"width":422,"blurWidth":0,"blurHeight":0};